module.exports = __webpack_public_path__ + "img/sub-main2.7d88dd09.jpg";